import moment from 'moment';
import i18n from 'i18next';
import { setDefaultLocale } from 'react-datepicker';
import momentDurationFormatSetup from 'moment-duration-format';
import { LOCALE_KEY } from '../../../consts/languages';

export type DurationMoment = Parameters<typeof momentDurationFormatSetup>[0];

momentDurationFormatSetup(moment as any as DurationMoment);

export const generateMomentDurationLocales = (translation: Record<string, string>) => {
  const fieldsMap = {
    S: 'duration_shortUnitMilisecond',
    SS: 'duration_shortUnitMilisecond',
    s: 'duration_shortUnitSecond',
    ss: 'duration_shortUnitSecond',
    m: 'duration_shortUnitMinute',
    mm: 'duration_shortUnitMinute',
    h: 'duration_shortUnitHour',
    hh: 'duration_shortUnitHour',
    d: 'duration_shortUnitDay',
    dd: 'duration_shortUnitDay',
    w: 'duration_shortUnitWeek',
    ww: 'duration_shortUnitWeek',
    M: 'duration_shortUnitMonth',
    MM: 'duration_shortUnitMonth',
    y: 'duration_shortUnitYear',
    yy: 'duration_shortUnitYear'
  };

  return {
    durationLabelsShort: Object.keys(fieldsMap).reduce((acc, key) => {
      return { ...acc, [key]: translation[fieldsMap[key as keyof typeof fieldsMap]] };
    }, {})
  };
};

export const updateDurationLocales = (curLocale: string) => {
  const defaultTranslation = i18n.getDataByLanguage(LOCALE_KEY.ENGLISH)?.translation;

  Object.keys(i18n.store.data).forEach(localeKey => {
    const localeTranslation = {
      ...defaultTranslation,
      ...i18n.getDataByLanguage(localeKey)?.translation
    };
    const durationStrings = generateMomentDurationLocales(localeTranslation);
    const nextLocale = localeKey.toLowerCase();
    moment.updateLocale(nextLocale, durationStrings);
  });
  changeMomentLocale(curLocale);
};

export const formatTranslations = (translations: Record<string, string>) => {
  Object.keys(translations).forEach((key) => {
    const match = /\[plural_(.*?)\]/.exec(key);
    if (match) {
      const newKey = key.replace(match[0], `_${match[1]}`);
      translations[newKey] = translations[key];
      delete translations[key];
    }
  });
  return translations;
};

export const changeLanguage = async (nextLanguage: string) => {
  if (i18n.language !== nextLanguage) {
    changeMomentLocale(nextLanguage);
    return i18n.changeLanguage(nextLanguage);
  }
};

export const changeMomentLocale = (locale: string) => {
  const nextLocale = locale.toLowerCase();
  moment.locale(nextLocale);
  setDefaultLocale(nextLocale);
};

export const getCurrentLanguage = () => i18n.language;